export interface AddTraining {
    training_topic_name: string;
    instructor_name: string;
    department_name: string;
    training_startDate: string | Date;
    training_endDate: string | Date;
    training_startTime: string;
    training_endTime: string;
    training_timeZone: string;
    training_link: string;
    training_document: string;
    training_documentname: string;
    venue_name: string;
    training_description: string;
    users_ids: any;
}

export interface TrainingDetail {
    training_id: string;
    topic_name: string;
    instructor_name: string;
    department_name: string;
    training_startDate: string | Date;
    training_endDate: string | Date;
    training_startTime: string;
    training_endTime: string;
    training_timeZone: string;
    training_link: string;
    training_document: string;
    venue_name: string;
    training_description: string;
    users_ids: any;
}

export interface TrainingSearch {
    keyword_search?: string;
}